
const color_palette_list = [
  
    { name: "red", color: "red" },
    { name: "green", color: "green" },
    { name: "blue", color: "blue" },
    { name: "yellow", color: "yellow" },
    { name: "pink", color: "pink" },
    { name: "white", color: "white" },
    { name: "gray", color: "gray" },
    { name: "black", color: "black" },
    { name: "lightblue", color: "lightblue" },
    { name: "cyan", color: "cyan" }
]
export default color_palette_list;